import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  height: 100%;
  overflow: hidden;
`;

export const WidgetContainer = styled.div`
  padding-top: 10px;
  height: 100%;
`;

export const Card = styled.div.attrs(props => ({
  filter: props.preview ? 'blur(2px)' : null,
  pointerEvents: props.preview ? 'none' : 'auto',
}))`
  display: flex;
  flex-direction: column;
  height: calc(100% - 15px);
  min-height: 230px;
  margin: 0 10px;
  border-radius: ${props => (props.platsView ? '0' : '8px')};
  padding: 19px 28px;
  background-color: ${props => (props.platsView ? 'inherit' : props.bgColor)};
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.4);
  color: #eee;
  filter: ${props => props.filter};
  pointer-events: ${props => props.pointerEvents};
`;

export const BorderTopCard = styled.div.attrs(props => ({
  filter: props.preview ? 'blur(2px)' : null,
  pointerEvents: props.preview ? 'none' : 'auto',
}))`
  display: flex;
  flex-direction: column;
  height: calc(100% - 15px);
  min-height: 230px;
  margin: 0 10px;
  border-radius: ${props => (props.platsView ? '0' : '8px')};
  padding: 10px 20px;
  background-color: ${props => (props.platsView ? 'inherit' : 'white')};
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.4);
  color: #323232;
  border-top: ${props => `7px solid ${props.color}`};
  filter: ${props => props.filter};
  pointer-events: ${props => props.pointerEvents};
`;

export const CardTitle = styled.div`
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 10px;
`;

export const DataRow = styled.div`
  display: flex;
  flex-direction: row;
`;

export const ContentText = styled.div`
  flex: 1;
  font-size: 16px;
  margin-right: 50px;
  font-weight: 300;

  p {
    margin-bottom: 0;
    line-height: 16px;
  }
`;
